import { render, staticRenderFns } from "./CoreIndexHistoryLibrary.vue?vue&type=template&id=40df24e0&scoped=true&"
import script from "./CoreIndexHistoryLibrary.vue?vue&type=script&lang=js&"
export * from "./CoreIndexHistoryLibrary.vue?vue&type=script&lang=js&"
import style0 from "./CoreIndexHistoryLibrary.vue?vue&type=style&index=0&id=40df24e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40df24e0",
  null
  
)

export default component.exports